<template>
  <div class="h-full">
    <div class="sidebar-layout__toolbar">
      <template v-if="!isMobile">
        <v-datepicker position-left v-model="date"></v-datepicker>
        <v-btn class="ml-4" :disabled="!hasPermission('loading', 'add')" medium @click="modal.showCreatePlanning = true">
          <v-icon position-left font-size="1" icon="plus"></v-icon>
          <span>{{ 'schedule.add_load' | translate }}</span>
        </v-btn>
      </template>
      <template v-else>
        <v-datepicker position-left v-model="date"></v-datepicker>
        <v-btn :disabled="!hasPermission('loading', 'add')" fab @click="modal.showCreatePlanning = true">
          <v-icon font-size="1.2" icon="plus"></v-icon>
        </v-btn>
      </template>
    </div>

    <v-dialog max-width="400" v-model="modal.showCreatePlanning">
      <create-planning-modal @update="updateData" @close="modal.showCreatePlanning = false"></create-planning-modal>
    </v-dialog>

    <planning-tabs />
    <tabs :date="date"></tabs>
    <planning-list ref="PlanningList"></planning-list>
  </div>
</template>

<script>
import { getDateForDatePicker } from '@/util'
import adaptationMixin from '@/mixins/adaptation.mixin.js'
import PlanningTabs from './common/PlanningTabs'
import Tabs from './tabs/Tabs.vue'
import PlanningList from './list/Index.vue'
import CreatePlanningModal from './list/dialogs/CreatePlanningModal'

export default {
  name: 'FarmPlanning',

  mixins: [adaptationMixin],

  components: {
    Tabs,
    CreatePlanningModal,
    PlanningList,
    PlanningTabs,
  },

  mounted () {
    this.date = getDateForDatePicker(this.timezone)
  },

  data () {
    return {
      date: null,
      modal: {
        showCreatePlanning: false
      }
    }
  },

  computed: {

    timezone () {
      return this.$store.getters['account/timezone']
    },
    farmId () {
      return this.$route.params.farm_id
    },

    loadingId () {
      return this.$route.query.loading
    }
  },

  methods: {
    updateData () {
      this.$refs.PlanningList.onUpdate()
    }
  },
  watch: {
    timezone (newVal) {
      this.date = getDateForDatePicker(newVal)
    }
  }
}
</script>
